import React from 'react';

import EdgeCrm from './edge_crm';
import LiteCrm from './lite_crm';

import type { Props as GenericProps } from './types';

interface Props extends GenericProps {
  edgeCrm: boolean;
}

export default function MapListItem({ edgeCrm, ...props }: Props) {
  const Component = edgeCrm ? EdgeCrm : LiteCrm;
  return <Component {...props} />;
}
